/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkResolveReference} from '../api'

export const useMutationBulkResolveReference = createReactQueryMutationHook('bulkResolveReference', bulkResolveReference)
